import { Compass } from "lucide-react";
import { useNovexData } from "@/hooks/useNovexData";
import { useLang } from "@/context/LanguageContext";
import { SessionBar } from "@/components/SessionBar";
import { MacroDrivers } from "@/components/MacroDrivers";
import { MacroScenarios } from "@/components/MacroScenarios";
import { CurrencyVolatility } from "@/components/CurrencyVolatility";
import { RiskGauge } from "@/components/RiskGauge";

export default function MacroOverview() {
  const { t, lang } = useLang();
  const { status, data, source } = useNovexData(`/ai/macro-analysis?lang=${lang}`, { maxPolls: 25, pollMs: 3000 });
  const drivers = data?.drivers;
  const scenarios = data?.scenarios;

  return (
    <div className="space-y-4" data-testid="macro-overview-page">
      <div className="flex items-center gap-3">
        <Compass className="h-7 w-7 text-blue-400" strokeWidth={1.8} />
        <div>
          <h1 className="font-heading text-2xl font-bold text-white">Macro Overview</h1>
          <p className="text-sm text-slate-500">{t("page.ovSub")}</p>
        </div>
      </div>

      <SessionBar />

      <div className="grid gap-4 lg:grid-cols-2">
        <MacroDrivers status={status} drivers={drivers} source={source} />
        <MacroScenarios status={status} scenarios={scenarios} source={source} />
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        <div className="rounded-lg border border-[#222733] bg-[#0E1118] p-4 sm:p-5">
          <h3 className="mb-3 font-heading text-xs font-bold uppercase tracking-wider text-slate-400">{t("page.ovRisk")}</h3>
          <RiskGauge compact />
        </div>
        <CurrencyVolatility />
      </div>
    </div>
  );
}
